
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[slug]/personalize",
      function () {
        return require("private-next-pages/shop/[slug]/personalize.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/[slug]/personalize"])
      });
    }
  